import { useEffect } from 'react';

export function useScrollLock(locked: boolean) {
  useEffect(() => {
    const previous = document.body.style.overflow;
    if (locked) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = previous || '';
    }
    return () => {
      document.body.style.overflow = previous || '';
    };
  }, [locked]);
}
